import type { LatLng } from '@/components/maps/map-controllers'

const NUM = '-?\\d+(?:\\.\\d+)?'
const PAIR = new RegExp(`^(${NUM})\\s*(?:,\\s*|\\s+)(${NUM})$`)

/**
 * Đọc chuỗi "vĩ độ, kinh độ" như Google Maps cho copy (vd "21.54119, 105.77732",
 * dấu phẩy hoặc khoảng trắng). Trả `null` nếu không phải đúng một cặp toạ độ
 * hợp lệ — khi đó ô tìm kiếm coi đây là tên địa điểm.
 */
export function parseLatLng(input: string): LatLng | null {
    const match = PAIR.exec(input.trim())
    if (!match) return null
    const lat = Number(match[1])
    const lng = Number(match[2])
    if (Math.abs(lat) > 90 || Math.abs(lng) > 180) return null
    return { lat, lng }
}
